<template>
  <div class="jin-post-head">
    <div v-if="details" class="jin-post-head-warp">
      <p v-if="show" class="jin-post-tip">您正在申请的岗位是</p>
      <div class="jin-post-head-title">
        <h3 :class="details.urgent ? 'post-emer' : 'post-hot'">{{ details.name }}</h3>
        <span v-if="attributesObj[details.attributes] === '兼职'">{{ `${details.min_salary} 元 / 小时` }}</span>
        <span v-else>{{ `${details.min_salary / 1000}k - ${details.max_salary / 1000}k ${ salaryType[details.salary_type] ? (' · ' + salaryType[details.salary_type]) : ''}` }}</span>
      </div>
      <div class="jin-post-head-info">
        <p>
          <span>广州</span>
          <span v-if="details.experience">经验{{ details.experience.replace(',', '-') }}年</span>
          <span>{{ details.qualification }}</span>
          <span>{{ attributesObj[details.attributes] }}</span>
        </p>
        <span v-if="show" class="date">发布日期：{{ dayjs(details.display_datetime).format('YYYY/MM/DD') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { attributesObj, salaryType } from '@/views/option'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      salaryType,
      attributesObj
    }
  },
  computed: {
    ...mapGetters([
      'details'
    ])
  }
}
</script>

<style lang="scss" scoped>
.jin-post {
  &-tip {
    color: #a0a4b7;
    line-height: 22px;
    margin-bottom: 18px;
  }

  &-head {
    background: #fff;

    &-warp {
      border-bottom: 1px solid #e8e8ea;
      padding: 60px 0;
    }

    &-title,
    &-info {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &-title {
      h3 {
        font-size: 30px;
        line-height: 42px;
        font-weight: 500;
        color: #3d4351;
        display: flex;
        align-items: center;

        &::before {
          content: '';
          padding-right: 7px;
          width: 24px;
          height: 24px;
          display: block;
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }
      }

      span {
        color: #ff5265;
        font-size: 26px;
        line-height: 37px;
      }
    }

    &-info {
      p {
        color: #3d4351;
        line-height: 22px;
        margin-top: 10px;

        span {
          &::after {
            content: ' / ';
          }

          &:nth-last-of-type(1) {
            &::after {
              display: none;
            }
          }
        }
      }

      span.date {
        color: #a0a4b7;
      }
    }
  }
}
</style>
